// tipo-ordem.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipoOrdem',
  standalone: true
})
export class TipoOrdemPipe implements PipeTransform {

  private tiposOrdens: { [key: string]: string } = {
    ACAO: 'Inclusão de Dívida',
    CEND: 'Consulta de Endereço',
    BAIXA: 'Baixa de Dívida',
    HISTORICO: 'Consulta de Histórico',
    REVOGACAO: 'Reinclusão de Dívida',
    OUTROS: 'Outros'
  };

  transform(value: string): string {
    return this.tiposOrdens[value] || value;
  }
}
